// extracted by mini-css-extract-plugin
export var statItem = "_gb-1";
export var statsRow = "_gb-0";